import { type MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';

import { emptyCellOneLevel } from '@/shared';
import { UsuariosSistemaGET } from '@/shared/interfaces';
import { BODEGAS } from '@/shared/interfaces/erp/inventario';

export const useColumnsUsuarioSistema = () => {

  const columnsBodegaUser = useMemo<MRT_ColumnDef<BODEGAS>[]>(() => [
    {
      id: 'accion',
      header: 'Acción',
    },
    {
      id: 'nombre',
      header: 'nombre',
    }
  ], [])

  const columnsSystemUser = useMemo<MRT_ColumnDef<UsuariosSistemaGET>[]>(
    () => [
      {
        accessorKey: 'name',
        header: 'NOMBRE',
        size: 300,
        Cell: ({ row }) =>
          row.original?.profile?.nombre
            ? `${row.original?.profile?.nombre} ${row.original?.profile?.apellido}`
            : row.original?.profile?.razon_social || 'N/A',
      },

      {
        accessorKey: 'username',
        header: 'USUARIO',
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, 'username'),
      },

      {
        accessorKey: 'email',
        header: 'EMAIL',
        size: 210,
        Cell: ({ row }) => emptyCellOneLevel(row, 'email'),
      },

      {
        accessorKey: 'identificacion',
        header: 'IDENTIFICACIÓN',
        size: 180,
        Cell: ({ row }) => row.original?.profile?.identificacion || 'N/A',
      },
      {
        accessorKey: 'tipo_identificacion',
        header: 'TIPO IDENTIFICACIÓN',
        size: 180,
        Cell: ({ row }) => row.original?.profile?.tipo_identificacion || 'N/A',
      },

      ///* fk
      {
        accessorKey: 'empresa',
        header: 'EMPRESA',
        size: 210,
        Cell: ({ row }) => row.original?.profile?.empresa || 'N/A',
      },
      {
        accessorKey: 'area',
        header: 'ÁREA',
        size: 210,
        Cell: ({ row }) => row.original?.profile?.area || 'N/A',
      },
      {
        accessorKey: 'departamento',
        header: 'DEPARTAMENTO',
        size: 210,
        Cell: ({ row }) => row.original?.profile?.departamento || 'N/A',
      },
      {
        accessorKey: 'canal_venta',
        header: 'CANAL VENTA',
        size: 210,
        Cell: ({ row }) => row.original?.profile?.canal_venta || 'N/A',
      },
      {
        accessorKey: 'rol',
        header: 'ROL',
        size: 180,
        Cell: ({ row }) => row.original?.profile?.rol || 'N/A',
      },
    ],
    []
  );

  const columnsControlCambiosUser = useMemo<MRT_ColumnDef<UsuariosSistemaGET>[]>(
    () => [
      {
        accessorKey: 'name',
        header: 'NOMBRE',
        size: 300,
        accessorFn: (row: any) => row.profile?.razon_social ?? row.full_name ?? row.username ?? "",//
        Cell: ({ row }) =>
          row.original?.profile?.nombre
            ? `${row.original?.profile?.nombre} ${row.original?.profile?.apellido}`
            : row.original?.profile?.razon_social || 'N/A',
      },

      {
        accessorKey: 'email',
        header: 'EMAIL',
        size: 210,
        accessorFn: (row: any) => row.email ?? "", /**/ 
        Cell: ({ row }) => emptyCellOneLevel(row, 'email'),
      },

      ///* fk

      {
        accessorKey: 'rol',
        header: 'ROL',
        size: 180,
        Cell: ({ row }) => row.original?.profile?.rol || 'N/A',
        accessorFn: (row: any) => row.profile?.rol ?? "",
      },
       {
        accessorKey: 'is_active',
        header: 'ESTADO',
        size: 180,
        Cell: ({ row }) => row.original?.is_active ? "Activo" : "Inactivo",
        accessorFn: (row: any) => (row.is_active ? "Activo" : "Inactivo"),//
        filterVariant: "select",
        filterSelectOptions: ["Activo", "Inactivo"],
        filterFn: "equals",
      },
      {
        accessorKey: 'telefono_1',
        header: 'Telefono',
        size: 180,
        Cell: ({ row }) => row.original?.empleado?.telefono_1 || 'N/A',
          accessorFn: (row: any) => row.empleado?.telefono_1 ?? "",
      },

      
    ],
    []
  );


  return {
    columnsSystemUser,
    columnsBodegaUser,
    columnsControlCambiosUser,
  };
};
